var _style, _desc, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutTimeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1907 767.5",
    style: {
      enableBackground: "new 0 0 1907 767.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st1{fill:#D7D7FF;}\r\n\t.st2{fill:#71CEFC;}\r\n\t.st3{fill:#92CDFA;}\r\n\t.st4{fill:#C7EBFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "about-timeline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "about-timeline",
    transform: "translate(0.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forma-oscura",
    transform: "translate(0.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(948.000000, 337.766996) scale(-1, 1) rotate(-180.000000) translate(-948.000000, -337.766996) translate(0.000000, 0.766996)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path-3-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M1893,110.4c-13.7,75.9-37.9,140-72.5,192.3s-89.8,109.1-165.6,170.4c-124.2,89.5-251.9,112-383.2,67.4 c-196.9-66.9-167,31.3-328.2,86.5s-399-148-526.4-136.8c-91.3,8-174,59.6-248.1,154.7c-21.5,34.7-94.6,42.2-131.4,0 s-44.9-96.3-29.2-162c17-71,134-217.6,160.6-386.9c9.7-62,37-119.4,109.2-134.9C388.6-62.4,466.7-25.3,550,15.7 C642,61,750.6,96.1,943.5,77.9c84.9-8,149.7-53.9,186.7-83.8c51.6-41.8,126.8-58.2,274,5.5C1551.3,63.2,1607.1-6,1653-38.8 c121.6-80.5,218.5-60.8,242.6,80.7C1897.8,54.9,1897,77.8,1893,110.4C1893.1,110.4,1893,110.4,1893,110.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.7667,
    y1: 97.7418,
    x2: 1389.7667,
    y2: 98.8696,
    gradientTransform: "matrix(1894.9955 0 0 673.6904 -2632653 -65933.7266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#202641"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3417,
    style: {
      stopColor: "#1B284C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9371,
    style: {
      stopColor: "#0F2E69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E2F6C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1893,110.4c-13.7,75.9-37.9,140-72.5,192.3s-89.8,109.1-165.6,170.4c-124.2,89.5-251.9,112-383.2,67.4 c-196.9-66.9-167,31.3-328.2,86.5s-399-148-526.4-136.8c-91.3,8-174,59.6-248.1,154.7c-21.5,34.7-94.6,42.2-131.4,0 s-44.9-96.3-29.2-162c17-71,134-217.6,160.6-386.9c9.7-62,37-119.4,109.2-134.9C388.6-62.4,466.7-25.3,550,15.7 C642,61,750.6,96.1,943.5,77.9c84.9-8,149.7-53.9,186.7-83.8c51.6-41.8,126.8-58.2,274,5.5C1551.3,63.2,1607.1-6,1653-38.8 c121.6-80.5,218.5-60.8,242.6,80.7C1897.8,54.9,1897,77.8,1893,110.4C1893.1,110.4,1893,110.4,1893,110.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "estrellas-Clipped",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrellas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(249.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(672.000000, 228.320299) scale(-1, 1) rotate(-180.000000) translate(-672.000000, -228.320299) translate(0.000000, 0.320299)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M780.7,437.1c0,0.9,0,1.8-0.2,2.6c0,0.2-0.7,2.3-0.9,2.2c-1.6-0.4-1.7-2.3-1.9-3.4 c-0.1-0.5-0.1-0.9-0.2-1.4c-0.9,0-1.7,0-2.5-0.2c-0.2-0.1-2.1-0.8-2.1-1c0.3-1.8,2.2-1.9,3.2-2.1c0.5-0.1,0.9-0.2,1.4-0.2 c0-0.1,0-0.2,0-0.3c0-0.8,0-1.5,0.2-2.3c0-0.2,0.7-2.3,0.9-2.2c1.6,0.3,1.8,2.2,1.9,3.3c0.1,0.5,0.1,1,0.1,1.5 c0.1,0,0.3,0,0.4,0c0.7,0,1.4,0,2.1,0.2c0.2,0.1,2.1,0.8,2.1,1c-0.3,1.7-2.1,2-3.1,2.1C781.7,437,781.2,437.1,780.7,437.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st2",
    d: "M1109.6-98.4c-0.6-0.1-1.3-0.2-1.9-0.2c-0.2,0-0.4,0-0.7,0c0-0.6-0.1-1.2-0.1-1.9 c-0.1-1-0.2-2.8-1.3-3.1c-0.2,0-0.6,1.9-0.6,2.1c-0.1,0.7-0.1,1.4-0.1,2.1c0,0.2,0,0.5,0,0.7c-0.5,0-1.1,0.1-1.6,0.1 c-0.9,0.1-2.5,0.2-2.8,1.5c0,0.2,1.7,0.7,1.9,0.7c0.8,0.2,1.7,0.2,2.6,0.2c0,0.6,0.1,1.2,0.1,1.8c0.1,1,0.2,2.9,1.3,3.2 c0.2,0.1,0.6-1.9,0.6-2.1c0.2-0.9,0.2-1.9,0.1-2.9c0.6,0,1.1-0.1,1.7-0.1c0.9-0.1,2.5-0.3,2.8-1.5 C1111.5-97.9,1109.8-98.4,1109.6-98.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st3",
    d: "M158.8-94.4c-1.7,0.6-1,3.8,0.7,3.6c0.4,0,0.7-0.2,1-0.5c0.1,0,0.1-0.1,0.2-0.1 C162.1-92.6,160.1-94.9,158.8-94.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.1,5.7c-1.7,0.6-1,3.8,0.7,3.6c0.4,0,0.7-0.2,1-0.5C2.9,8.8,3,8.7,3,8.7C4.4,7.5,2.4,5.2,1.1,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.2,274.8c0,0.8,0,1.7-0.2,2.5c0,0.2-0.6,2.1-0.8,2.1c-1.5-0.3-1.6-2.1-1.7-3.2 c-0.1-0.4-0.1-0.9-0.2-1.3c-0.8,0-1.6,0-2.4-0.2c-0.2,0-2-0.7-1.9-0.9c0.3-1.6,2-1.8,2.9-1.9c0.4-0.1,0.9-0.1,1.3-0.2 c0-0.1,0-0.2,0-0.3c0-0.7,0-1.4,0.2-2.1c0-0.2,0.6-2.1,0.8-2.1c1.4,0.3,1.7,2,1.8,3.1c0.1,0.5,0.1,0.9,0.1,1.4 c0.1,0,0.3,0,0.4,0c0.7,0,1.3,0,2,0.2c0.2,0,2,0.7,1.9,1c-0.3,1.6-1.9,1.9-2.9,2C344.2,274.7,343.7,274.7,343.2,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1461.1,168.4c-1.7,0.6-1,3.8,0.7,3.6c0.4,0,0.7-0.2,1-0.5c0.1,0,0.1-0.1,0.2-0.1 C1464.4,170.2,1462.4,167.9,1461.1,168.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1040.3,224.7c-1.7,0.6-1,3.8,0.7,3.6c0.4,0,0.7-0.2,1-0.5c0.1,0,0.1-0.1,0.2-0.1 C1043.6,226.5,1041.6,224.2,1040.3,224.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M597.2,221.1c-3.4,1.3-2,7.5,1.5,7.2c0.7-0.1,1.4-0.4,1.9-1c0.1-0.1,0.3-0.1,0.4-0.3 C603.8,224.6,599.8,220.1,597.2,221.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.2,163.4c0,0.8,0,1.7-0.2,2.5c0,0.2-0.6,2.1-0.8,2.1c-1.5-0.3-1.6-2.1-1.7-3.2 c-0.1-0.4-0.1-0.9-0.2-1.3c-0.8,0-1.6,0-2.4-0.2c-0.2,0-2-0.7-1.9-0.9c0.3-1.6,2-1.8,3-2c0.4-0.1,0.9-0.1,1.3-0.2 c0-0.1,0-0.2,0-0.3c0-0.7,0-1.4,0.2-2.1c0-0.2,0.6-2.1,0.8-2.1c1.4,0.3,1.7,2,1.8,3.1c0.1,0.5,0.1,0.9,0.1,1.4 c0.1,0,0.3,0,0.4,0c0.7,0,1.3,0,2,0.2c0.2,0,2,0.7,2,1c-0.3,1.6-1.9,1.9-2.9,2C127.1,163.3,126.7,163.4,126.2,163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1251.9,48.3c0,0.8,0,1.6-0.2,2.4c0,0.2-0.6,2.1-0.8,2.1c-1.4-0.3-1.5-2.1-1.7-3.1 c-0.1-0.4-0.1-0.9-0.2-1.3c-0.8,0-1.6,0-2.3-0.2c-0.2,0-2-0.7-1.9-0.9c0.3-1.6,2-1.7,2.9-1.9c0.4-0.1,0.9-0.1,1.3-0.2 c0-0.1,0-0.2,0-0.3c0-0.7,0-1.4,0.2-2.1c0-0.2,0.6-2.1,0.8-2.1c1.4,0.3,1.6,2,1.7,3c0.1,0.5,0.1,0.9,0.1,1.4 c0.1,0,0.3,0,0.4,0c0.7,0,1.3,0,2,0.2c0.2,0,2,0.7,1.9,0.9c-0.3,1.6-1.9,1.8-2.8,2C1252.9,48.3,1252.4,48.3,1251.9,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1494.9-127.7c-0.8-0.2-1.6-0.2-2.4-0.2c-0.3,0-0.5,0-0.8,0c0-0.8-0.1-1.5-0.1-2.3 c-0.1-1.3-0.3-3.4-1.6-3.8c-0.2-0.1-0.7,2.4-0.8,2.6c-0.1,0.9-0.2,1.8-0.2,2.7c0,0.3,0,0.6,0,0.9c-0.6,0-1.3,0.1-1.9,0.2 c-1.1,0.2-3.1,0.3-3.5,1.8c-0.1,0.2,2.1,0.8,2.3,0.9c1,0.2,2.1,0.2,3.2,0.2c0,0.7,0.1,1.5,0.2,2.2c0.2,1.3,0.3,3.5,1.6,4 c0.2,0.1,0.7-2.4,0.8-2.6c0.2-1.2,0.2-2.4,0.2-3.6c0.7,0,1.4-0.1,2.1-0.2c1.1-0.1,3-0.3,3.4-1.8 C1497.2-127,1495.1-127.6,1494.9-127.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1324.9,378.3c-0.8-0.2-1.7-0.2-2.6-0.2c-0.3,0-0.6,0-0.9,0c0-0.8-0.1-1.7-0.1-2.5 c-0.1-1.4-0.3-3.7-1.8-4.2c-0.2-0.1-0.8,2.6-0.9,2.8c-0.2,0.9-0.2,1.9-0.2,2.9c0,0.3,0,0.7,0,1c-0.7,0-1.4,0.1-2.1,0.2 c-1.2,0.2-3.4,0.3-3.8,2c-0.1,0.2,2.3,0.9,2.5,1c1.1,0.2,2.3,0.2,3.5,0.2c0,0.8,0.1,1.6,0.2,2.4c0.2,1.4,0.3,3.9,1.7,4.3 c0.2,0.1,0.8-2.6,0.8-2.8c0.2-1.3,0.2-2.6,0.2-3.9c0.7,0,1.5-0.1,2.2-0.2c1.2-0.1,3.3-0.4,3.7-2 C1327.4,379,1325.1,378.3,1324.9,378.3"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutTimeline);
export default __webpack_public_path__ + "static/media/about-timeline.15468d31c91494c0b3ecb846f338384b.svg";
export { ForwardRef as ReactComponent };